export const DEFAULT_TOOL_MENU_COLOR_SET = {
  selected: {
    bg: '#0b1b3e',
    icon: '#fafafa',
  },
  normal: {
    bg: 'transparent',
    icon: '#424242',
  },
};

export enum TOOL_MENU_TYPE {
  DEFAULT = 'default',
  IMMEDIATELY = 'immediately',
  SWITCH = 'switch',
  TOGGLE = 'toggle',
}
